import React from 'react';
import clsx from 'clsx';
import { PriceBox } from './PriceBox';

type ServiceProps = {
    services: any[];
    addService: (service: string) => void;
    removeService: (service: string) => void;
    title: string;
    children?: React.ReactNode;
};

export function ServiceBox({services, addService, removeService, title, children}: ServiceProps) {
  
  return (
    <div className='tw-mt-4 tw-mb-10'>
      <h1>{title}</h1>
      <div className='md:tw-shadow-outline-gray tw-mt-5 tw-bg-white'>
            <div className={clsx('tw-flex tw-flex-col md:tw-flex-row md:tw-items-stretch md:tw-justify-between',
              'tw-border tw-border-solid tw-border-gray-200',
              'tw-shadow-outline-gray md:tw-shadow-none'
            )}>
                <div className='tw-p-3 md:tw-px-4 tw-flex tw-flex-row tw-items-center tw-gap-2'>
                  {children}
                </div>
                <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-justify-end'>
                  {services.map((segment, index) => {
                    const service = segment.service;
                    const action = service.selected ? removeService : addService;

                    return <PriceBox key={index} 
                      service={service} 
                      selected={service.selected} 
                      included={service.included} 
                      currencyCode={segment.currencyCode} 
                      onClick={() => action(segment.logicalFlightId)} />
                  })}
                </div>
            </div>
      </div>
    </div>
  )

}